import { render } from "./AssistenciaSocial.vue?vue&type=template&id=34706b0b"
const script = {}

import exportComponent from "/Users/rhylton/Sites/xviconferenciaassistenciasocial/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__